import { MOKA_SERVICE_HOST } from 'api/constants';

export const GET_LOYALTY = () => `${MOKA_SERVICE_HOST}/loyalty/v3/programs`;
